import { render, staticRenderFns } from "./Retro_old.vue?vue&type=template&id=0f0f0192&scoped=true&"
import script from "./Retro_old.vue?vue&type=script&lang=js&"
export * from "./Retro_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f0192",
  null
  
)

export default component.exports